import { FC, ReactElement, useEffect, useState } from 'react';

interface DroppableCompProps {
  dropComp: ReactElement;
}

const DroppableComp: FC<DroppableCompProps> = ({ dropComp }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return dropComp;
};

export default DroppableComp;
